<template>
  <div>
    <CCard>
      <CCardHeader class="d-flex justify-content-between align-items-center">
        <h3 style="margin-top: 8px;">{{ $i18n.t("licitadores.consultar") }}</h3>
        <CustomExport :lista="listaLicitadoresFiltrados" :fields="camposLicitadores" :name="'Lista de licitadores'"></CustomExport>
      </CCardHeader>
      <CCardBody>
        <CDataTable
            hover
            striped
            :tableFilter="{ placeholder: 'Introducir valor', label: 'Buscar', external: true, lazy: true }"
            :table-filter-value.sync="tableFilterVal"
          :itemsPerPageSelect="{
            label: 'Elementos por página',
            values: [5, 10, 15, 20, 25],
          }"
          :items-per-page="5"
            :items="listaLicitadoresFiltrados"
            :fields="camposLicitadores"
            sorter
            pagination
          >
            <template #acciones="{ item }">
              <td>
                <CButton color="secondary" style="margin-left: 10px" @click="openDetails(item.id)">Ver detalles</CButton>
              </td>
            </template>
            <template #situacion="{ item }">
              <td>
                <CBadge :color="getBadge(item.situacion)">{{
                  item.situacion
                }}</CBadge>
              </td>
            </template>
          </CDataTable>
      </CCardBody>
    </CCard>

    <CModal
      title="Información"
      :show.sync="evento"
      size="sm"
      centered
    >
      {{ getMessage() }}
    </CModal>
  </div>
</template>

<style scoped>

</style>

<script>
import Cookies from "js-cookie";
import CustomExport from '../../utils/CustomExport'
import { setTableFilterValue } from '../../utils/filterUtils'
import { logOut } from "../../utils/authUtils";
import { getAllLicitadores } from '../../requests/licitadores'

export default {
  name: "ConsultarLicitadores",
  components: {
    CustomExport
  },
  created() {

  },
  mounted(){
    this.evento = this.$route.query.evento;

    getAllLicitadores().then(res => {
      this.listaLicitadores = res.data;
      this.listaLicitadoresFiltrados = this.listaLicitadores

    }).catch(error => {
      if (error.response.status == 403 || error.response.status == 401) logOut(this.$router);
    })
  },
  data() {
    return {
      evento: undefined,
      listaLicitadores: [],
      listaLicitadoresFiltrados: [],
      tableFilterVal: "",
      camposLicitadores: [
        { key: "id", label:"ID" },
        { key: "nombre", label:"Nombre completo" },
        { key: "dnicif", label:"DNI / CIF" },
        { key: "acciones", label:"Acciones" },
      ]
    };
  },
  computed: {
    tableState() {
      return [
        this.tableFilterVal,
      ];
    }
  },
  watch: {
    tableState() {
      this.listaLicitadoresFiltrados = this.listaLicitadores
      this.setTableFilter();
    }
  },
  methods: {
    getBadge(situacion){
      return situacion == "Valido" ? "success" : "danger";
    },
    openDetails(idLicitador){
      this.$router.push({ path: "/licitadores/detalle?id="+idLicitador})
    },
    getMessage(){ //en funcion del evento mostrará un mensaje u otro
      if(this.evento){
        switch(this.evento){
          case "created": //cuando redirija despues de crear un concurso correctamente
            return "Licitador creado correctamente";
        }
      }
    },
    setTableFilter() {
      this.listaLicitadoresFiltrados = setTableFilterValue(this.tableFilterVal, this.listaLicitadoresFiltrados)
    },
  },

  beforeDestroy() {

  },
};
</script>
